export const authConstants = {
     LOGIN_REQUEST: "LOGIN_REQUEST",
     LOGIN_SUCCESS: "LOGIN_SUCCESS",
     LOGIN_FAILURE: "LOGIN_FAILURE",
};

export const projectConstants = {
     GET_PROJECTS_REQUEST: "GET_USER_PROJECTS_REQUEST",
     GET_PROJECTS_SUCCESS: "GET_USER_PROJECTS_SUCCESS",
     GET_PROJECTS_FAILURE: "GET_USER_PROJECTS_FAILURE",

     GET_PROJECT_DETAILS_BY_ID_REQUEST: " GET_PROJECT_DETAILS_BY_ID_REQUEST",
     GET_PROJECT_DETAILS_BY_ID_SUCCESS: " GET_PROJECT_DETAILS_BY_ID_SUCCESS",
     GET_PROJECT_DETAILS_BY_ID_FAILURE: " GET_PROJECT_DETAILS_BY_ID_FAILURE",
};
